import {
  Card,
  Chip,
  Table,
} from '@heroui/react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import * as React from 'react'
import { authApiClient } from '~/lib/api-client'

export const Route = createFileRoute('/admin/languages')({
  component: LanguagesPage,
})

function LanguagesPage() {
  const { data: languages } = useSuspenseQuery({
    queryKey: ['admin', 'languages'],
    queryFn: async () => {
      const res = await authApiClient.languages.$get()
      if (!res.ok)
        throw res
      return await res.json()
    },
  })

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Languages</h1>
        <p className="text-muted mt-1 font-medium">System language overview.</p>
      </div>

      <Card variant="secondary" className="max-w-3xl">
        <Table>
          <Table.ScrollContainer>
            <Table.Content aria-label="Languages table">
              <Table.Header>
                <Table.Column isRowHeader>Name</Table.Column>
                <Table.Column>Code</Table.Column>
                <Table.Column>Status</Table.Column>
              </Table.Header>
              <Table.Body>
                {languages.map((lang: any) => (
                  <Table.Row key={lang.id}>
                    <Table.Cell className="font-bold">{lang.name}</Table.Cell>
                    <Table.Cell><code className="text-xs bg-muted px-1 rounded">{lang.code}</code></Table.Cell>
                    <Table.Cell>
                      <Chip color="success" variant="soft" size="sm">Active</Chip>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Content>
          </Table.ScrollContainer>
        </Table>
      </Card>
    </div>
  )
}
